import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/projects/page.tsx");
